import axios from '@services/axios'
import UserStore from '@stores/UserStore'

export default {
  // 获取考试类别数据
  examTree: () => {
    return axios.get(
      '/learn/app/clientapi/exam/qualify/tree.do',
      {
        params: {
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 试卷类型下拉框数据
  examSubject: (examId: string) => {
    return axios.get(
      '/learn/app/clientapi/exam/qualify/subjects.do',
      {
        params: {
          examId,
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 试卷综合查询，下拉框切换时获取试卷信息
  examPanel: (subjectId: string) => {
    return axios.get(
      '/learn/app/clientapi/exam/qualify/panel.do',
      {
        params: {
          subjectId,
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 获取章节下所有的试卷
  getChapterList: (params: any) => {
    return axios.get(
      `/learn/app/clientapi/exam/qualify/paperList.do`,
      {
        params: {
          pageNo:params.pageNo,
          pageSize: params.pageSize,
          paperType:params.paperType,
          subjectId:params.subjectId,
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 获取章节信息
  getChapterInfo: (params: any) => {
    return axios.get(
      `/learn/app/clientapi/exam/qualify/chapters.do`,
      {
        params: {
          pageNo:params.pageNo,
          pageSize: params.pageSize,
          subjectId:params.subjectId,
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 获取试卷详情
  getPaperDetail: (paperId: string) => {
    return axios.get(
      '/learn/app/clientapi/exam/qualify/paperDetail.do',
      {
        params: {
          paperId,
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 交卷
  submitPaperData: (params: any) => {
    return axios.post(
      '/learn/app/clientapi/exam/qualify/submitEnding.do',
      params,
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          sid: UserStore.getSid(),
        }
      }
    )
  },
  // 获取错题列表
  getWrongList: (params: any) => {
    return axios.get(
      '/learn/app/clientapi/exam/qualify/wrongList.do',
      {
        params: {
          pageNo:params.pageNo,
          pageSize: params.pageSize,
          subjectId:params.subjectId,
          sid: UserStore.getSid(),
        }
      }
    )
  },
  // 查询错题详情
  getWrongDetail: (questionId: string) => {
    return axios.get(
      '/learn/app/clientapi/exam/qualify/queryQuestionDetail.do',
      {
        params: {
          questionId,
          sid: UserStore.getSid(),
        }
      }
    )
  },
  // 删除错题
  deleteWrongData: (questionId: string) => {
    return axios.get(
      '/learn/app/clientapi/exam/qualify/removeWrongRecord.do',
      {
        params: {
          questionId,
          sid: UserStore.getSid(),
        }
      }
    )
  },
}


